// GENERATED by scripts/version-info.ts at build time. Committed placeholder for local typechecks.
export const BUILD = "0.28.0-alpha.85+edbc840";
export const CHANNEL = "alpha";
export const SHA = "edbc840";
